// extracted by mini-css-extract-plugin
module.exports = {"SizeTwoLines":"styles_SizeTwoLines__1FuKE","CheckboxButtonIcon":"styles_CheckboxButtonIcon__244ID","btnDetail":"styles_btnDetail__24bk3"};